import './ContactScreen.css'
import { useState } from 'react'
import PageHeader from '../../components/PageHeader/PageHeader'

interface ContactForm {
  name: string
  email: string
  subject: string
  message: string
}

const ContactScreen = () => {
  const [formData, setFormData] = useState<ContactForm>({
    name: '',
    email: '',
    subject: '',
    message: ''
  })
  const [submitSuccess, setSubmitSuccess] = useState(false)

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    const body = `${formData.message}\n\nNafn: ${formData.name}\nNetfang: ${formData.email}`
    const mailto = `mailto:velvirki@velvirki.is?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(body)}`

    window.location.href = mailto
    setSubmitSuccess(true)
  }

  return (
    <div className="contact-screen">
      <PageHeader
        eyebrow="Hafa samband"
        title="Við erum til þjónustu reiðubúin"
        lede="Hafðu samband við okkur með því að fylla út formið hér að neðan eða notaðu upplýsingarnar til hægri til að ná beint sambandi."
      />

      <div className="contact-content">
        <div className="contact-grid">
          <div className="contact-form-section">
            <h2>Sendu okkur línu</h2>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Nafn:"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  placeholder="Netfang:"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Efni:"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <textarea
                  placeholder="Skilaboð:"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={6}
                  required
                />
              </div>

              <button
                type="submit"
                className="submit-button"
              >
                Senda skilaboð
              </button>

              {submitSuccess && (
                <div className="success-message">
                  Póstforritið þitt ætti að hafa opnast með skilaboðunum. Þú getur líka sent
                  beint á velvirki@velvirki.is.
                </div>
              )}
            </form>
          </div>

          <div className="contact-info-section">
            <h2>Hafðu samband</h2>
            
            <div className="contact-info-block">
              <h3>Heimilisfang</h3>
              <p>Hafnarbraut 7</p>
              <p>620 Dalvík</p>
            </div>

            <div className="contact-info-block">
              <h3>Opnunartími</h3>
              <p>Mánudaga - Föstudaga</p>
              <p>08:00 - 16:00</p>
            </div>

            <div className="contact-info-block">
              <h3>Símar</h3>
              <p>Skrifstofa: 466-1088</p>
              <p>Helgi: 696-2145</p>
              <p>Eiður Máni: 893-2173</p>
            </div>

            <div className="contact-info-block">
              <h3>Netfang</h3>
              <p>velvirki@velvirki.is</p>
            </div>

            <div className="map-container">
              <iframe 
                src="https://www.openstreetmap.org/export/embed.html?bbox=-18.532276153564457%2C65.97115675115022%2C-18.52553844451904%2C65.97290471477857&amp;layer=mapnik&amp;marker=65.97203073974097%2C-18.528907299041748"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactScreen 